const HighlightItem = ({ value, type, wrapperStyle, icon }) => {
	return (
		<div className={`flex gap-xsmall ${wrapperStyle} highlightItem`}>
			{type !== "text" && <i className={`pi ${icon}`} />}
			{type !== "icon" && <span>{value}</span>}
		</div>
	);
};

export default HighlightItem;
